// JobClose AI · Slice 2U · SupportRoute
// Router guard: admin-only. Mirrors AdminGuard's shape but scoped
// specifically to the Support workspace so future access controls can
// diverge without disturbing the legacy Admin surface.
import { Navigate, Outlet } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

export default function SupportRoute() {
  const { user } = useAuth();
  if (user?.role !== "admin") return <Navigate to="/app" replace />;
  return <Outlet />;
}
